module.exports = __webpack_public_path__ + "static/media/close-icon-dark.004d8187.svg";